// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Reset (Preflight) */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}

html {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
}

body {
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-main);
  color: var(--text-primary);
  font-family: 'Inter', system-ui, sans-serif;
}

/* Overflow hidden on desktop, mobile needs normal scroll */
@media (min-width: 768px) {
  body {
    overflow: hidden;
  }
}

img,
svg,
video,
canvas {
  display: block;
  max-width: 100%;
}

button,
input,
textarea,
select {
  font: inherit;
  color: inherit;
}

button {
  cursor: pointer;
  background: none;
  border: none;
}

a {
  color: inherit;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

ul,
ol {
  list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base/reset.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA,2DAA2D;AAC3D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":["/* CSS Reset (Preflight) */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml {\n  line-height: 1.5;\n  -webkit-text-size-adjust: 100%;\n  tab-size: 4;\n}\n\nbody {\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-main);\n  color: var(--text-primary);\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n/* Overflow hidden on desktop, mobile needs normal scroll */\n@media (min-width: 768px) {\n  body {\n    overflow: hidden;\n  }\n}\n\nimg,\nsvg,\nvideo,\ncanvas {\n  display: block;\n  max-width: 100%;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font: inherit;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  background: none;\n  border: none;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\nul,\nol {\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
